import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import api from '../../services/api';

import { addNotification, clearNotifications, clearOneNotification } from './actions';

export const fetchNotifications = createAsyncThunk(
    'notifications/fetchNotifications',
    async function (type, { dispatch }) {
        let route = '/notifications/';
        if (type !== undefined) {
            route += `?type=${type}`;
        }
        const response = await api.get(route);
        return response.data;

    });
const initialState = {
    notifications: [],

}

const notificationsReducer = createReducer(
    initialState,
    {

        [fetchNotifications.fulfilled]: (state, action) => {
            state.notifications = action.payload;
        },

        [addNotification]: (state, action) => {
            state.notifications.push(action.payload);
        },
        [clearNotifications]: (state, action) => {
            state.notifications = []
        },
        [clearOneNotification]: (state, action) => {

            const notificationId = action.payload._id

            state.notifications = state.notifications.filter(notification => notification._id !== notificationId);


        },
    })




export default notificationsReducer;